import * as React from 'react';
import { Box, Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

function DateRangePicker({ value = [null, null], onChange, name }) {
  const [start, end] = value.map(v => (v ? dayjs(v) : null));

  const sendAsTargetValue = newValue => ({
    target: { name, value: newValue },
  });

  const handleStartChange = newValue => {
    onChange(sendAsTargetValue([newValue || null, value[1] || null]));
  };

  const handleEndChange = newValue => {
    onChange(sendAsTargetValue([value[0] || null, newValue || null]));
  };

  return (
    <Box>
      <Stack direction="row" spacing={2}>
        <DatePicker
          value={start}
          onChange={handleStartChange}
          slotProps={{
            textField: { size: 'small', fullWidth: true },
            field: {
              clearable: true,
              onClear: () => handleStartChange(null),
            },
          }}
        />
        <DatePicker
          value={end}
          onChange={handleEndChange}
          slotProps={{
            textField: { size: 'small', fullWidth: true },
            field: {
              clearable: true,
              onClear: () => handleEndChange(null),
            },
          }}
        />
      </Stack>
    </Box>
  );
}

export default DateRangePicker;
